import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { Config } from "helpers/backend_helper"
import { DASHNOTIFICATIONS } from "helpers/url_helper"

const SidebarContent = props => {
  const [modules, setModules] = useState("");
  const [category, setCategory] = useState("");
  const [isAdmin, setIsAdmin] = useState(false)
  const [isComplaintsManager, setIsComplaintsManager] = useState(false)
  const metisMenuRef = useRef(null);
  const [notifications, setNotifications] = useState([])
  const [hrProfile, setHRProfile] = useState(true)

  const fetchData = () =>{
    try {
      const obj = JSON.parse(localStorage.getItem("authWTUser"));
      const data = { userId:obj.id }
      if(obj.hrNo != ""){
        setHRProfile(true)
      }
      if(obj.userModules){
        setModules(obj.userModules);
      }
      if(obj.category){
        setCategory(obj.category);
      }
      if(obj.category == "ADMINISTRATOR"){ 
        setIsAdmin(true); 
      }
      if(obj.category == "COMPLAINT MANAGER"){ 
        setIsComplaintsManager(true); 
      }
      axios.post(DASHNOTIFICATIONS, JSON.stringify(data), Config).then((r)=>{
        setNotifications(r.data)
      }).catch((e)=>{
        console.log(e)
      })
    } catch (error) {
      console.error(error.message);
    }
  }
  
  useEffect(() => {
    fetchData();
  }, []);

  const ref = useRef();
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      if (metisMenuRef.current) {
        metisMenuRef.current.dispose(); // Dispose of previous instance if exists
      }
      metisMenuRef.current = new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    initMenu();
    ref.current.recalculate();

    return () => {
      if (metisMenuRef.current) {
        metisMenuRef.current.dispose(); 
      }
    };
  }, [props.location.pathname, isAdmin, isComplaintsManager, modules]);

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent ? parent.childNodes[1] : null;
  
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
  
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
  
      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag
  
        const parent3 = parent2.parentElement; // li tag
  
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }
  

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{""}</li>
            <li>
              <Link to="/#" className="">
                <i className="bx bx-home-circle"></i>
                <span>Dashboard</span>
              </Link>
              
            </li>
            <li>
              <Link to="/Notifications" className="">
                <i className="bx bx-shield-alt"></i>
                <span className="badge rounded-pill bg-danger float-end">
                  {(notifications || []).length}
                </span>
                <span>Notifications</span>
              </Link>
            </li>
            {modules.includes("WATER PRODUCTION") && (
              <li>
                <Link to="/water-production" className=""><i className="bx bxs-detail"></i><span>Water Production</span> </Link>
              </li>
            )}
             {modules.includes("CMMS") && (<>
              <li>
                <Link to="/#" className="has-arrow">
                <i className="bx bx-task"></i>
                <span>Asset Maintenance</span>
                </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li><Link to="/Asset-Map" className=""> Asset Map</Link></li>     
                    <li><Link to="/Asset-Register" className="">Asset Register</Link></li>
                    <li><Link to="/Work-Requests" className="">Work Requests</Link></li>      
                    <li><Link to="/Work-Order-Management" className="">Work Orders</Link></li>     
                    <li><Link to="/PPM-Calendar" className="" >Preventive Maintenance</Link></li>     
                    <li><Link to="/PPM-Library" className="" >Preventive Library</Link></li>     
                    {/*
                    <li><Link to="/Spares-and-Materials" className="">Spares and Materials</Link></li>     
                    <li><Link to="/Maintenance-Reports" className="">Maintenance Reports</Link></li>
                    */}
                  </ul>
              </li>
            </>)}
            {modules.includes("CCTS") && (<>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-user-detail"></i>
                <span>Customer Support</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li><Link to="/Customer-Complaints">Customer Complaints</Link></li>
                <li><Link to="/Call-Center-Reports">Complaints Report</Link></li>
                {(isAdmin || isComplaintsManager) && (<>
                <li><Link to="/Call-Center">Call Center</Link></li>
                <li><Link to="/Complaints-Categories">Complaints Categories</Link></li>
                <li><Link to="/Complaint-Messages">Complaints Messages</Link></li>
                </>)}
              </ul>
            </li>
            </>)}
            <li>
              <Link to="#" className="">
                <i className="bx bx-receipt"></i>
                <span className="badge rounded-pill badge-soft-success float-end"  key="t-new">New</span>
                <span key="t-email-templates">Billing System</span>
              </Link>
            </li>
            {modules.includes("PAYMENTS") && (<>
            <li>
              <Link to="/Bill-Payments" className="">
                <i className="bx bx-money"></i>
                <span>E - Payments</span>
              </Link>
            </li>
            </>)}
            <li>
              <Link to="#" className="">
                <i className="bx bx-briefcase-alt-2"></i>
                <span className="badge rounded-pill badge-soft-success float-end"  key="t-new">New</span>
                <span key="t-email-templates">Accounting System</span>
              </Link>
            </li>
            {modules.includes("INVENTORY") && (<>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-file"></i>
                <span key="t-email-templates">Inventory Management</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li><Link to="/Inventory">Inventory</Link></li>
                <li><Link to="#" >Purchase Orders</Link></li>
                <li><Link to="/Stock-Movement">Stock Movement</Link></li>
                <li><Link to="/Suppliers-and-Contractors">Suppliers and Contractors</Link></li>
                <li><Link to="/Inventory-Setup">Setup</Link></li>
              </ul>
            </li>
            </>)}
            {modules.includes("WQMIS") && (<>
            <li>
              <Link to="/GIS" className="">
                <i className="bx bx-loader"></i>
                <span>GIS</span>
              </Link>
            </li>
            </>
            )}
            {modules.includes("WQMIS") && (<>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-flask"></i>
                <span>Water Quality</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li><Link to="/Water-Sampling">Collected Samples</Link></li>
                <li><Link to="/Sampling-Points">Sampling Points</Link></li>
                <li><Link to="/Sampling-Points-Map">Sampling Points Map</Link></li>
                <li><Link to="/Parameters">Parameters</Link></li>
                <li><Link to="/Sampling-Report">Sampling Reports</Link></li>
              </ul>
            </li>
            </>)}
            <li>
              <Link to="#" className="has-arrow" >
                <i className="mdi mdi-account-star"></i>
                
                <span key="t-email-templates">Self Service Portal</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li><Link to="/personal-details">My Data</Link></li>
                {/*<li><Link to="#">My Attendance</Link></li>*/}
                <li><Link to="/personal-leave-plan">My Leave plans</Link></li>
                <li><Link to="/personal-leave">My Leave Application</Link></li>
                {/*<li><Link to="#">My Performance Agreements</Link></li>
                <li><Link to="#">My Appraisals</Link></li>*/}
                <li><Link to="/personal-disciplinary-and-grievancies">My Grievances</Link></li>
                <li><Link to="#">My Payslips</Link></li>
                {/*<li><Link to="#">My Loans</Link></li>*/}
              </ul>
            </li>
            {modules.includes("HRMIS") && (<>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="mdi mdi-human-queue"></i>
                <span>Human Resources</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li><Link to="/human-resources">HR Dashoard</Link></li>
                <li><Link to="/employees">Employees</Link></li>
                <li><Link to="/organogram">Organogram</Link></li>
                <li><Link to="/leave-planning">Leave Planning</Link></li>
                <li><Link to="/leave-management">Leave Management</Link></li>
                <li><Link to="/performance-agreements">Performance Agreements</Link></li>
                <li><Link to="/appraisals">Appraisals</Link></li>
                <li><Link to="/attendance">Attendance</Link></li>
                <li><Link to="/payroll">Payroll</Link></li>
                <li><Link to="/pay-adjustments">Pay Adjustments</Link></li>
                {/*<li><Link to="/pay-adjustments-reports">Pay Adjustments Reports</Link></li>*/}
                <li><Link to="/disciplinary-and-grievancies">Disciplinary & Grievances</Link></li>
                <li><Link to="/#">Staff Training</Link></li>
                <li><Link to="/#">Recruitments</Link></li>
                <li><Link to="/human-resource-settings">Setup</Link></li>
                
              </ul>
            </li>
            </>)}
            {isAdmin && <li>
                <Link to="/#" className="has-arrow ">
                  <i className="bx bx-wrench"></i>
                  <span>System Settings</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li><Link to="/system-users">System Users</Link></li>
                  <li><Link to="/other-setup">Other Settings</Link></li>
                </ul>
              </li>
            }
           

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
